<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>¿Cómo estaba integrado el ejército mexicano?</h2>
    <img @click="imageClicked(0)" src="galerias/gameRoom/MEXICANOS.png" class="mainphoto"/>
    <p class="photo-description">
      Título: <b>Batalla del 5 de mayo de 1862 (detalle Zacapoaxtlas)</b><br>
      Autor: Patricio Ramos<br>
      Año: siglo XIX<br>
      Técnica: Óleo sobre tela.<br>
      Medidas: Alto: 146 cms. Ancho: 198 cms.<br>
      Colección: colección del Museo Regional Casa de Alfeñique
    </p>
    <p>Las tropas mexicanas estaban constituidas por alrededor de 5 mil hombres, casi todos soldados recién reclutados, y comandadas por el célebre general Ignacio Zaragoza.</p>
    <p>Recibieron refuerzos de comunidades indígenas para rechazar a los Franceses, en su mayoría provenían de Zacapoaxtla, Tetela de Ocampo, algunos oriundos de Cuetzalan, Nauzontla, Xochiapulco y Xochitlán. A este grupo se le llegó a conocer como el batallón Zacapoaxtla.</p>
  </div>
</template>

<script>
export default {
  name: "GameM2",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    }
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
